/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/* Search text dynamic */
const words = [  
  "Camisa Turquesa   ",
  "Camisa Azul Marino   ",
  "Pantalón Coral   ",
  "Chaqueta Natural   "
];

let cont = 0;
let timer;


let id_placeholder = 'typer';
if (screen.width <= 640 && document.getElementById("inp3")) {
  id_placeholder = 'inp3';
}


function typingEffect() {
  let word = words[cont].split("");
  var loopTyping = function() {
    if (word.length > 0) {
      let elem = document.getElementById(id_placeholder);
      elem.setAttribute('placeholder', elem.getAttribute('placeholder') + word.shift());
    } else {
      deletingEffect();
      return false;
    };
    timer = setTimeout(loopTyping, 120);
  };
  loopTyping();
};


function deletingEffect() {
  let word = words[cont].split("");
  var loopDeleting = function() {
    if (word.length > 0) {
      word.pop();
      document.getElementById(id_placeholder).setAttribute('placeholder', word.join(""));
    } else {
      if (words.length > (cont + 1)) {
        cont++;
      } else {
        cont = 0;
      };
      typingEffect();
      return false;
    };
    timer = setTimeout(loopDeleting, 100);
  };
  loopDeleting();
};

typingEffect();


/* Toggle close results */ 

function toggleX() {
  var inp3 = document.getElementById("inp3").value;
  if(document.getElementById("inp3").value.trim() == ''){
    document.getElementById("closeSearchBar").style.display = 'none';
  } else {
    document.getElementById("closeSearchBar").style.display = 'block';
  }
}

function resultsHide() {
  document.getElementById("Search__ResultsMobile").setAttribute("aria-hidden", "true");
  document.getElementById("Search__FormMobile").reset();
  document.getElementById("closeSearchBar").style.display = 'none';
}

function toggleUnfolded() {
  var inp3 = document.getElementById("typer").value;
  if(document.getElementById("typer").value.trim() == ''){
    document.getElementById("closeSearchBarUnfolded").style.display = 'none';
  } else {
    document.getElementById("closeSearchBarUnfolded").style.display = 'block';
  }
}

function resultsHideUnfolded() {
  document.getElementById("Search__ResultsUnfolded").setAttribute("aria-hidden", "true");
  document.getElementById("Search__FormUnfolded").reset();
  document.getElementById("closeSearchBarUnfolded").style.display = 'none';
}

/* Search bar effect */ 


var prevScrollpos = window.pageYOffset;
window.onscroll = function() {

  var currentScrollPos = window.pageYOffset;
  
  if (prevScrollpos >= currentScrollPos) {
    document.getElementById("shopify-section-search-bar").style.top = "97px";
    document.getElementById("shopify-section-search-bar").style.zIndex  = "3";
  } else {
    var attr = document.getElementById("Search__ResultsMobile").getAttribute('aria-hidden');
    if (attr == "true") {
      document.getElementById("shopify-section-search-bar").style.top = "0px";
    }
  }
  prevScrollpos = currentScrollPos;
  
      
        var currentScrollPos = window.pageYOffset;
      
       if(currentScrollPos > 200){
              $('.arrow-up').show();
        }else{
          $('.arrow-up').hide();
        }
}


function toTop(){
    var page = $("html, body");
     page.on(
          "scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove",
          function () {
            page.stop();
          }
        );
      page.animate(
      { scrollTop: 0},
      500,
      function () {
        page.off(
          "scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove"
        );
      }
    );

    return false;
}


/* product hover sizes */ 
/*
setTimeout(function () {
  ProductItemHoverEffect();
}, 1000)

function ProductItemHoverEffect() {
  const queryString = window.location.pathname; 
  const elements = document.getElementsByClassName('ProductItem');

  Array.from(elements).forEach(function(element) {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        // is mobile..
    } else {
        element.addEventListener('mouseover', () => {
          if(queryString.length > 1){
            element.querySelector('.product-sizes-list').style.display = 'block';
          }
        })
        element.addEventListener('mouseout', () => {
          element.querySelector('.product-sizes-list').style.display = 'none';
        })
	}
  })
}
*/

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

/*
function slidevideo() {
  $('#shopify-section-1606987660ce797635').hide();
  $('#shopify-section-1654092510a7f61743').show();
  setTimeout(slideimages, 15000);
}

function slideimages() {

  $('#shopify-section-1654092510a7f61743').hide();
  $('#shopify-section-1606987660ce797635').show();
  setTimeout(slidevideo, 15000);
}
*/

/* blink tab */ 
/*
window.onload = function() {

  var pageTitle = document.title;
  let attentionMessage = '🔥 Tenemos novedades increíbles';
  var blinkEvent = null;

  document.addEventListener('visibilitychange', function(e) {
    var isPageActive = !document.hidden;

    if(!isPageActive){
      blink();
    }else {
      document.title = pageTitle;
      clearInterval(blinkEvent);
    }
  });

  function blink(){
    blinkEvent = setInterval(function() {
      if(document.title === attentionMessage){
        document.title = pageTitle;
      }else {
        document.title = attentionMessage;
      }
    }, 2000);
  }
};
*/

function recommendationsInCartAux(){
   $('.product-recommendations-cart').html('<img id="loading" src="https://cdn.shopify.com/s/files/1/0427/4834/6533/files/loading.gif?v=1716885070" />');
  // setTimeout(() => {
     if($(".Cart__Empty").length == 0)
      {
        $.ajax({
        url: window.Shopify.routes.root + "recommendations/products?product_id="+$('.CartItem__Id').first().text()+"&limit=4&section_id=cart-recommendations-section&intent=related",
        context: document.body
        }).done(function(data) {
            $('.product-recommendations-cart').html(data)
        });
      }else{
        $('.product-recommendations-cart').html()
        $('.product-recommendations-cart').hide();
      }
     /* $(".owl-carousel-cart").owlCarousel({
        items:1,
        loop:true
      });*/
   //  }, 1500);

      
}

function recommendationsInCart(){
  $('.product-recommendations-cart').show();
   $('.product-recommendations-cart').html('<img id="loading" src="https://cdn.shopify.com/s/files/1/0427/4834/6533/files/loading.gif?v=1716885070" />');
   setTimeout(() => {
     if($(".Cart__Empty").length == 0)
      {
        $.ajax({
        url: window.Shopify.routes.root + "recommendations/products?product_id="+$('.CartItem__Id').first().text()+"&limit=4&section_id=cart-recommendations-section&intent=complementary",
        context: document.body
        }).done(function(data) {
          if(data.length<=87){
            recommendationsInCartAux()
          }else{
            $('.product-recommendations-cart').html(data)
          }
        });
      }else{
        $('.product-recommendations-cart').html();
        $('.product-recommendations-cart').hide();
      }
    /*  $(".owl-carousel-cart").owlCarousel({
        items:1,
        loop:true
      });*/
     }, 1500);
    setTimeout(() => {
      $('.pr-arrow-img-right').effect("pulsate", { times:1 }, 2000);
     }, 2000);
 
}

function cartRecommendationsRight(){
     //$('.pr-arrow.pr-right').on('click', function(event) {
     // event.stopPropagation();
      $( "#product-recommendations" ).animate( { scrollLeft: '100%' }, 500);
      $('.pr-arrow.pr-right').hide();
      $('.pr-arrow.pr-left').show();
      $('.pr-arrow-img-left').effect("pulsate", { times:1 }, 2000);

   // });
}

function cartRecommendationsLeft(){
  // $('.pr-arrow.pr-left').on('click', function(event) {
  //  event.stopPropagation();
    $( "#product-recommendations" ).animate( { scrollLeft: '0%' }, 500);
    $('.pr-arrow.pr-right').show();
    $('.pr-arrow.pr-left').hide();
    $('.pr-arrow-img-right').effect("pulsate", { times:1 }, 2000);
  //});
}

function closeCartNote(){
    $(".Cart__Note.Form__Textarea").val('');
    $('.Drawer.Drawer--fromRight').removeClass('has-note-open');
    $('.Cart__OffscreenNoteContainer').attr('aria-hidden', 'true'); 
}

function closeRecommendations(){
    $(".product-recommendations-cart").slideUp();
}


$( document ).ready(function() {
  
  $('.ShopTheLook__Dot').click(function() {
      $('#shopify-section-search-bar').hide();
  });
  
    $('.Popover__Close').click(function() {
      $('#shopify-section-search-bar').show();
  });


/*  $('#sidebar-cart').on( "change", function() {
    recommendationsInCart();
  } );*/

  $('.Icon-Wrapper--clickable').on( "click", function() {
    recommendationsInCart();
  } );

  $('.ProductForm__AddToCart').on( "click", function() {
    recommendationsInCart();
  } );



});